import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "graph-controls row" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "year-span" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Update")
const _hoisted_7 = { class: "legend" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle legend-trigger" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["line-graph", _ctx.wrapperClasses])
  }, [
    _withDirectives(_createElementVNode("div", {
      class: "pi pi-map top-right-inner",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleLegend && _ctx.toggleLegend(...args)))
    }, null, 512), [
      [
        _directive_tooltip,
        _ctx.legendTip,
        void 0,
        { bottom: true }
      ]
    ]),
    _createVNode(_component_Chart, {
      type: "line",
      data: _ctx.graphData,
      options: _ctx.options,
      ref: "linegraph"
    }, null, 8, ["data", "options"]),
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", null, _toDisplayString(_ctx.p1Name), 1),
          _withDirectives((_openBlock(), _createBlock(_component_SelectButton, {
            modelValue: _ctx.p1Keys,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.p1Keys) = $event)),
            options: _ctx.grahOpts1,
            optionLabel: "name",
            optionValue: "key",
            multiple: true,
            class: "mode-button row"
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("i", {
                class: _normalizeClass(slotProps.option.icon)
              }, null, 2)
            ]),
            _: 1
          }, 8, ["modelValue", "options"])), [
            [
              _directive_tooltip,
              _ctx.grahaGroupLabel,
              void 0,
              { top: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", null, _toDisplayString(_ctx.p2Name), 1),
          _withDirectives((_openBlock(), _createBlock(_component_SelectButton, {
            modelValue: _ctx.p2Keys,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.p2Keys) = $event)),
            options: _ctx.grahOpts2,
            optionLabel: "name",
            optionValue: "key",
            multiple: true,
            class: "mode-button row"
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("i", {
                class: _normalizeClass(slotProps.option.icon)
              }, null, 2)
            ]),
            _: 1
          }, 8, ["modelValue", "options"])), [
            [
              _directive_tooltip,
              _ctx.grahaGroupLabel,
              void 0,
              { top: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createVNode(_component_InputNumber, {
          modelValue: _ctx.startYear,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startYear) = $event)),
          min: 1700,
          max: _ctx.maxStartYear,
          useGrouping: false,
          class: "year-field"
        }, null, 8, ["modelValue", "max"]), [
          [
            _directive_tooltip,
            _ctx.startYearLabel,
            void 0,
            { left: true }
          ]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_Button, { onClick: _ctx.updateYearRange }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [
            _directive_tooltip,
            _ctx.endRangeTip,
            void 0,
            { top: true }
          ]
        ]),
        _withDirectives(_createVNode(_component_InputNumber, {
          modelValue: _ctx.endYear,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endYear) = $event)),
          min: 1720,
          max: _ctx.maxYear,
          useGrouping: false,
          class: "year-field"
        }, null, 8, ["modelValue", "max"]), [
          [
            _directive_tooltip,
            _ctx.endYearLabel,
            void 0,
            { right: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("aside", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("dl", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.symbols, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.itemKey
          }, [
            _createElementVNode("dt", null, [
              _createElementVNode("span", {
                class: _normalizeClass(["symbol", item.classNames])
              }, _toDisplayString(item.icon), 3)
            ]),
            _createElementVNode("dd", null, _toDisplayString(item.name), 1)
          ], 64))
        }), 128))
      ])
    ])
  ], 2))
}